// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* Theme CSS Variables - Default Light Theme */
:root {
  --color-primary: #8B7355;
  --color-secondary: #6B5744;
  --color-accent: #5C4033;
  --color-bg: #F9F6F1;
  --color-bgSecondary: #F5EFE7;
  --color-border: #E8DCC8;
  --color-borderDark: #D5C4A1;
  --color-text: #5C4033;
  --color-textSecondary: #8B7355;
  --color-textMuted: #B8A894;
}

/* Theme-specific global styles */
body.theme-dark {
  background-color: #1a1614 !important;
  color: #E8DCC8 !important;
}

body.theme-green {
  background-color: #f0f8f3 !important;
  color: #1e4a2d !important;
}

body.theme-blue {
  background-color: #f0f6f9 !important;
  color: #1d4a6a !important;
}

body.theme-purple {
  background-color: #f6f0f9 !important;
  color: #4a1d6a !important;
}

/* Dark theme specific */
.theme-dark nav,
.theme-dark .bg-\\\\[\\\\#F5EFE7\\\\],
.theme-dark .bg-\\\\[\\\\#F9F6F1\\\\] {
  background-color: #2a2420 !important;
}

.theme-dark .text-\\\\[\\\\#5C4033\\\\],
.theme-dark .text-\\\\[\\\\#8B7355\\\\] {
  color: #E8DCC8 !important;
}

.theme-dark .border-\\\\[\\\\#E8DCC8\\\\],
.theme-dark .border-\\\\[\\\\#D5C4A1\\\\] {
  border-color: #3a3430 !important;
}

.App {
  min-height: 100vh;
}

/* Custom scrollbar for webkit browsers */
::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-track {
  background: #F5EFE7;
}

::-webkit-scrollbar-thumb {
  background: #D5C4A1;
  border-radius: 5px;
}

::-webkit-scrollbar-thumb:hover {
  background: #8B7355;
}

/* Smooth transitions */
button,
a,
input,
select {
  transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease;
}

/* Focus states */
button:focus-visible,
input:focus-visible,
select:focus-visible {
  outline: 2px solid #8B7355;
  outline-offset: 2px;
}

/* Hide watermark */
[class*="watermark"],
[id*="watermark"],
div[style*="position: fixed"][style*="bottom"][style*="right"] {
  display: none !important;
  visibility: hidden !important;
  opacity: 0 !important;
}

/* Bottom Navigation Animations */
@keyframes shimmer {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}

.animate-shimmer {
  animation: shimmer 2s infinite;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.animate-fade-in-up {
  animation: fadeInUp 0.3s ease-out;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA,8CAA8C;AAC9C;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,uBAAuB;EACvB,mBAAmB;EACnB,4BAA4B;EAC5B,uBAAuB;EACvB,2BAA2B;EAC3B,qBAAqB;EACrB,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA,iCAAiC;AACjC;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA,wBAAwB;AACxB;;;EAGE,oCAAoC;AACtC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;AACnB;;AAEA,yCAAyC;AACzC;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;;;;EAIE,+EAA+E;AACjF;;AAEA,iBAAiB;AACjB;;;EAGE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;;;EAGE,wBAAwB;EACxB,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA,iCAAiC;AACjC;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,iCAAiC;AACnC","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n/* Theme CSS Variables - Default Light Theme */\n:root {\n  --color-primary: #8B7355;\n  --color-secondary: #6B5744;\n  --color-accent: #5C4033;\n  --color-bg: #F9F6F1;\n  --color-bgSecondary: #F5EFE7;\n  --color-border: #E8DCC8;\n  --color-borderDark: #D5C4A1;\n  --color-text: #5C4033;\n  --color-textSecondary: #8B7355;\n  --color-textMuted: #B8A894;\n}\n\n/* Theme-specific global styles */\nbody.theme-dark {\n  background-color: #1a1614 !important;\n  color: #E8DCC8 !important;\n}\n\nbody.theme-green {\n  background-color: #f0f8f3 !important;\n  color: #1e4a2d !important;\n}\n\nbody.theme-blue {\n  background-color: #f0f6f9 !important;\n  color: #1d4a6a !important;\n}\n\nbody.theme-purple {\n  background-color: #f6f0f9 !important;\n  color: #4a1d6a !important;\n}\n\n/* Dark theme specific */\n.theme-dark nav,\n.theme-dark .bg-\\\\[\\\\#F5EFE7\\\\],\n.theme-dark .bg-\\\\[\\\\#F9F6F1\\\\] {\n  background-color: #2a2420 !important;\n}\n\n.theme-dark .text-\\\\[\\\\#5C4033\\\\],\n.theme-dark .text-\\\\[\\\\#8B7355\\\\] {\n  color: #E8DCC8 !important;\n}\n\n.theme-dark .border-\\\\[\\\\#E8DCC8\\\\],\n.theme-dark .border-\\\\[\\\\#D5C4A1\\\\] {\n  border-color: #3a3430 !important;\n}\n\n.App {\n  min-height: 100vh;\n}\n\n/* Custom scrollbar for webkit browsers */\n::-webkit-scrollbar {\n  width: 10px;\n}\n\n::-webkit-scrollbar-track {\n  background: #F5EFE7;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #D5C4A1;\n  border-radius: 5px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #8B7355;\n}\n\n/* Smooth transitions */\nbutton,\na,\ninput,\nselect {\n  transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease;\n}\n\n/* Focus states */\nbutton:focus-visible,\ninput:focus-visible,\nselect:focus-visible {\n  outline: 2px solid #8B7355;\n  outline-offset: 2px;\n}\n\n/* Hide watermark */\n[class*=\"watermark\"],\n[id*=\"watermark\"],\ndiv[style*=\"position: fixed\"][style*=\"bottom\"][style*=\"right\"] {\n  display: none !important;\n  visibility: hidden !important;\n  opacity: 0 !important;\n}\n\n/* Bottom Navigation Animations */\n@keyframes shimmer {\n  0% {\n    transform: translateX(-100%);\n  }\n  100% {\n    transform: translateX(100%);\n  }\n}\n\n.animate-shimmer {\n  animation: shimmer 2s infinite;\n}\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.animate-fade-in-up {\n  animation: fadeInUp 0.3s ease-out;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
